(() => {
  'use strict';

  const VERSION = '9.7.3';

  function isReviewStep(designer) {
    const active = designer?.querySelector('[data-me-step-button].is-active, [data-me-step-button][aria-current="step"]');
    if (active?.dataset?.meStepButton === 'review') return true;
    const reviewPanel = designer?.querySelector('[data-me-step-panel="review"]');
    return Boolean(reviewPanel && !reviewPanel.hidden);
  }

  function projectQuantity(designer) {
    const sizeInputs = Array.from(designer?.querySelectorAll?.('[data-me-size-quantity]') || []);
    if (sizeInputs.length) {
      return sizeInputs.reduce(
        (sum, input) => sum + Math.max(0, Number.parseInt(input.value || '0', 10) || 0),
        0
      );
    }

    const quantityInput = designer?.querySelector('[data-me-quantity-input]');
    return Math.max(0, Number.parseInt(quantityInput?.value || '0', 10) || 0);
  }

  function isQuoteRequired(designer) {
    if (!designer) return false;
    if (designer.dataset.meCustomApparelQuoteRequired === 'true') return true;
    return projectQuantity(designer) >= 21;
  }

  document.addEventListener('click', (event) => {
    const visibleAction = event.target.closest?.('[data-me-designer-primary-action]');
    if (!visibleAction) return;

    const designer = visibleAction.closest('[data-me-designer]');
    if (!designer || !isReviewStep(designer)) return;

    // v15.4.7.40 — 21+ is a quote-only workflow. Do NOT bridge the visible
    // footer action to the hidden review-submit control, because that control
    // owns the cart path. Falling through allows me-designer-v2's native
    // primary-action handler to route the project to the bulk-quote handoff.
    if (isQuoteRequired(designer)) return;

    // Route the visible fixed-footer action through the original review-submit
    // control. me-designer-v2 owns the actual validation and cart workflow.
    const reviewSubmit = designer.querySelector('[data-me-review-submit]');
    if (!reviewSubmit || reviewSubmit === visibleAction) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (visibleAction.disabled || visibleAction.getAttribute('aria-busy') === 'true') return;

    reviewSubmit.click();
  }, true);

  console.info(`[Moments ${VERSION}] Project review submit bridge ready.`);
})();
